const $win = $(window);

/**
 * Create markup for slides
 * @param  { Object } $holder      DOM Element - slider holder
 * @param  { String } currentColor color handle
 * @return { Void }
 */
export function createSlides($holder) {
  let imagesForCurrentColor = [];

  if (window.productImages !== undefined) {
    for (let i = 0; i < window.productImages.images.length; i++) {
      if (window.productImages.images[i].videoType == 'vimeo') {
        $.ajax({
          url: `https://vimeo.com/api/v2/video/${window.productImages.images[i].videoID}.json"`,
          type: 'GET',
          dataType: 'json',
          success: function(response) {
            const imageSrc = response[0].thumbnail_large.split(/\d{3}(?=.jpg)/);
            const thumbImage = `${imageSrc[0]}190${imageSrc[1]}`;
            const placeholderImage = `${imageSrc[0]}1110${imageSrc[1]}`;

            $('.js-slider-thumbs-popup .thumb--video .thumb__image').css('background-image', `url(${thumbImage})`);
            //$('.js-slider-product .slider__slide--video .video__image').css('background-image', `url(${placeholderImage})`);
          }
        });
      }

      const imageElements = [
        window.productImages.images[i].alt,
        window.productImages.images[i].feature,
        window.productImages.images[i].thumb,
        window.productImages.images[i].link,
        window.productImages.images[i].videoType,
        window.productImages.images[i].videoLink,
        window.productImages.images[i].videoPlaceholder,
        window.productImages.images[i].videoThumb
      ];

      imagesForCurrentColor.push(imageElements);
    }

    if (imagesForCurrentColor.length) {
      $('.default-image').removeClass('show');
      $('.slider-product').show();
      $holder.removeClass('hide');
      $('.label-current-color').addClass('hidden-label');
    }

    for (let i = 0; i < imagesForCurrentColor.length; i++) {
      if ($holder.hasClass('js-slider-thumbs-popup')) {
        if (imagesForCurrentColor[i][4] != undefined) {
          $holder.slick('slickAdd', markupThumb(imagesForCurrentColor[i], true));
        } else {
          $holder.slick('slickAdd', markupThumb(imagesForCurrentColor[i], false));
        }
      }

      if ($holder.hasClass('js-slider-product-popup')) {
        if (imagesForCurrentColor[i][4] != undefined) {
          $holder.slick('slickAdd', markupSlide(imagesForCurrentColor[i], true, imagesForCurrentColor[i][4]));
        } else {
          $holder.slick('slickAdd', markupSlide(imagesForCurrentColor[i], false, ''));
        }

        // const $popupBtn = $holder.find('.slick-slide:not(.slick-cloned) .slider__slide-image');
        // initPopup($popupBtn, popupOptions);

        $holder.slick('slickGoTo', 0);
        $holder.closest('.slider-product').removeAttr('style');
        $holder.closest('.slider-product').height($holder.closest('.slider-product').height());
      }
    }
  }
}

/**
 * Markup slides for large images
 * @param  { Array } slidePartsArray Array with parts of slide
 * @param  { Boolean } hasVideo      Has video on this slide
 * @param  { String } videoType      Video type (vimeo or youtube)
 * @return { String }
 */
function markupSlide(slidePartsArray, hasVideo, videoType) {
  if (hasVideo) {
    let videoIframe = '';
    let additionalClasses = '';

    if (videoType === 'vimeo') {
      const videoSrc = slidePartsArray[5].split('/')[slidePartsArray[5].split('/').length - 1];

      videoIframe = `<iframe src="https://player.vimeo.com/video/${videoSrc}?badge=0" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
    }

    if (videoType === 'youtube') {
      const videoSrc = slidePartsArray[5].split('=')[slidePartsArray[5].split('=').length - 1];

      videoIframe = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoSrc}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    }

    if (slidePartsArray[8] === 'true') {
      additionalClasses = 'video-simple--vertical';
    }

    return `<div class="slick-slide">
              <div>
                <div class="slider__slide slider__slide--video">
                  <div class="video-simple ${additionalClasses}">
                    ${videoIframe}
                  </div><!-- /.video-simple -->
                </div><!-- /.slider__slide -->
              </div>
            </div><!-- /.slick-slide -->`;
  } else {
    return `<div class="slick-slide">
              <div>
                <div class="slider__slide">
                  <div class="slider__slide-image">
                    <img src="${slidePartsArray[1]}" alt="${slidePartsArray[0]}" />
                  </div><!-- /.slider__slide-image -->
                </div><!-- /.slider__slide -->
              </div>
            </div><!-- /.slick-slide -->`;
  }
}

/**
 * Markup slides for thumb images
 * @param  { Array } slidePartsArray Array with parts of slide
 * @param  {Boolean} hasVideo        Has video on this slide
 * @return { String }
 */
function markupThumb(slidePartsArray, hasVideo) {
  if (hasVideo) {
    return `<div class="slick-slide">
              <div>
                <div class="thumb thumb--video">
                  <div class="thumb__image" style="background-image: url(${slidePartsArray[7]});"></div><!-- /.thumb__image -->
                </div><!-- /.thumb -->
              </div>
            </div><!-- /.slick-slide -->`;
  } else {
    return `<div class="slick-slide">
              <div>
                <div class="thumb">
                  <img src="${slidePartsArray[1]}" alt="${slidePartsArray[0]}" />
                </div><!-- /.thumb -->
              </div>
            </div><!-- /.slick-slide -->`;
  }
}



// WEBPACK FOOTER //
// ../assets/js/create-slides.js